function a(e) {
  return e.replace(/sekuntia?/, "sekunnin");
}
function s(e) {
  return e.replace(/minuuttia?/, "minuutin");
}
function f(e) {
  return e.replace(/tuntia?/, "tunnin");
}
function l(e) {
  return e.replace(/päivää?/, "päivän");
}
function c(e) {
  return e.replace(/(viikko|viikkoa)/, "viikon");
}
function k(e) {
  return e.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function t(e) {
  return e.replace(/(vuosi|vuotta)/, "vuoden");
}
var v = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: a
  },
  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: a
  },
  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: function(r) {
      return "puolen minuutin";
    }
  },
  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: s
  },
  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: s
  },
  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: f
  },
  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: f
  },
  xDays: {
    one: "päivä",
    other: "{{count}} päivää",
    futureTense: l
  },
  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: c
  },
  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: c
  },
  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: k
  },
  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: k
  },
  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: t
  },
  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: t
  },
  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: t
  },
  almostXYears: {
    one: "lähes vuosi",
    other: "lähes {{count}} vuotta",
    futureTense: t
  }
}, h = function(r, i, u) {
  var n = v[r], o = i === 1 ? n.one : n.other.replace("{{count}}", String(i));
  return u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? n.futureTense(o) + " kuluttua" : o + " sitten" : o;
};
const T = h;
export {
  T as default
};
